import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';

const useOperationDictionary = () => {
  const see_answer_label = FindLangKey(
    'lab-patient-see-asnwers-lab'
  );

  const accept_answer_label = FindLangKey(
    'lab-patient-operation-accept-answer-operation'
  );

  const cancel_answer_label = FindLangKey(
    'lab-patient-cancel-answer'
  );

  const reject_answer_label = FindLangKey(
    'lab-patient-reject-answer'
  );

  const confirm_get_answer = FindLangKey(
    'lab-patient-confirm-see-answer'
  );

  const confirm_see_answer = FindLangKey(
    'lab-patient-confirm-accept-answer'
  );
  const confirm_accept_answer = FindLangKey(
    'lab-patient-confirm-cancel-answer'
  );
  const confirm_cancel_answer = FindLangKey(
    'lab-patient-confirm-reject-answer'
  );
  const reject_reason = FindLangKey(
    'lab-patient-reject-reason'
  );

  const data = [
    see_answer_label,
    accept_answer_label,
    cancel_answer_label,
    reject_answer_label,
    confirm_get_answer,
    confirm_see_answer,
    confirm_accept_answer,
    confirm_cancel_answer,
    reject_reason,
  ];

  return data;
};

export default useOperationDictionary;
